import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateManagerService } from '../translate/translate-manager.service';

export class TnLoaderState {
  isLoading: boolean;
  isShowSpinner: boolean;
  message: string;
  isShowingAlert: boolean;
  isReconnecting: boolean;

  constructor(isLoading, isShowSpinner, message, isShowingAlert?, isReconnecting?) {
    this.isLoading = isLoading;
    this.isShowSpinner = isShowSpinner;
    this.message = message;
    this.isShowingAlert = isShowingAlert;
    this.isReconnecting = isReconnecting;
  }
}

@Injectable()
export class TnLoaderService {

  loader: TnLoaderState = new TnLoaderState(false, false, '', false, false);
  loader$: BehaviorSubject<TnLoaderState> = new BehaviorSubject<TnLoaderState>(this.loader);

  constructor(private _translateManagerService: TranslateManagerService) { 
  }

  showLoading() {
    if (this.loader.isReconnecting) {
      this._translateManagerService.getTranslationByKey('LOADING.RECONNECTING', (string) => {
        this.loader = new TnLoaderState(true, true, string, this.loader.isShowingAlert, this.loader.isReconnecting);
        this.loader$.next(this.loader);
      });

      return
    }

    this.loader = new TnLoaderState(true, false, '', this.loader.isShowingAlert);
    this.loader$.next(this.loader);
  }

  hideLoading() {
    if (this.loader.isShowSpinner) {
      return;
    }

    if (this.loader.isReconnecting) {
      return;
    }
    
    this.loader = new TnLoaderState(false, false, '', this.loader.isShowingAlert);
    this.loader$.next(this.loader);
  }

  showSpinner(msg?: string) {
    this.loader = new TnLoaderState(true, true, msg ? msg : '', this.loader.isShowingAlert);
    this.loader$.next(this.loader);
  }

  hideSpinner() {
    this.loader = new TnLoaderState(false, false, '', this.loader.isShowingAlert);
    this.loader$.next(this.loader);
  }

  showReconnectingSpinner(msg?: string) {
    this.loader = new TnLoaderState(
      true,
      true,
      msg ? msg : '', 
      false, 
      true
    );
    this.loader$.next(this.loader);
  }

  hideReconnectingSpinner() {
    this.loader = new TnLoaderState(
      false,
      false,
      '',
      false,
      false
    );
    this.loader$.next(this.loader);
  }

  showAlertHandling() {
    this.loader = new TnLoaderState(
      this.loader.isLoading,
      this.loader.isShowSpinner,
      this.loader.message,
      true
    );
    this.loader$.next(this.loader);
  }

  hideAlertHandling() {
    this.loader = new TnLoaderState(
      this.loader.isLoading,
      this.loader.isShowSpinner,
      this.loader.message,
      false
    );
    this.loader$.next(this.loader);
  }

}
